<div class="progress-cont" [ngClass]="{'bg-active-danger': error}">
  <div class="progress" [style.width]="progress + '%'" [ngClass]="{'bg-danger': error}">
  </div>
</div>
